import React from "react"

import { Sheet, SheetContent, SheetTrigger } from "@/components/ui"
import ScreenLayout from "@/layouts/screen"
import { sendHaptic } from "@/modules/helpers/utils"

interface SideSheetProps {
  open: boolean
  setOpen: (open: boolean) => void
  trigger: React.ReactNode
  children: React.ReactNode
  side: "right" | "left" | "top" | "bottom"
}

export function SideSheet({ open, setOpen, trigger, children, side }: SideSheetProps) {
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger
        onClick={() => {
          setOpen(true)
          sendHaptic()
        }}
      >
        {trigger}
      </SheetTrigger>
      <SheetContent className="w-full max-w-full" side={side} hiddenClose>
        <ScreenLayout transition="none">{children}</ScreenLayout>
      </SheetContent>
    </Sheet>
  )
}
